export default __webpack_public_path__ + "static/media/base-bg.054483d7.jpg";